<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-users"></i>
        <h2>Selecionar Cliente</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="modal-search">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          class="search-input" 
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Buscar por nome, CPF/CNPJ, telefone ou email..."
          autofocus>
      </div>
    </div>

    <!-- Customer List -->
    <div class="modal-body">
      <div class="customers-list">
        <!-- Loading -->
        <div class="loading-state" *ngIf="isLoading">
          <i class="fas fa-spinner fa-spin"></i>
          <p>Carregando clientes...</p>
        </div>

        <!-- Customer Items -->
        <div 
          *ngFor="let customer of filteredCustomers"
          class="customer-item"
          [class.selected]="selectedCustomer?.id === customer.id"
          (click)="selectCustomer(customer)">
          <div class="customer-icon">
            <i class="fas fa-user-circle"></i>
          </div>
          <div class="customer-info">
            <div class="customer-name">{{ customer.nome }}</div>
            <div class="customer-details">
              <span><i class="fas fa-id-card"></i> {{ customer.cpfCnpj }}</span>
              <span><i class="fas fa-phone"></i> {{ customer.telefone }}</span>
            </div>
            <div class="customer-email">
              <i class="fas fa-envelope"></i> {{ customer.email }}
            </div>
          </div>
          <div class="customer-check" *ngIf="selectedCustomer?.id === customer.id">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>

        <!-- No Results -->
        <div class="no-results" *ngIf="!isLoading && filteredCustomers.length === 0">
          <i class="fas fa-search"></i>
          <p>Nenhum cliente encontrado</p>
          <p class="hint" *ngIf="searchTerm.length >= 2">Tente buscar com outro termo</p>
          <p class="hint" *ngIf="searchTerm.length > 0 && searchTerm.length < 2">Digite pelo menos 2 caracteres para buscar</p>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="modal-pagination" *ngIf="!isLoading && totalPages > 1">
      <div class="pagination-info">
        <span>Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalCount) }} de {{ totalCount }} clientes</span>
      </div>
      <div class="pagination-controls">
        <button
          class="btn-pagination"
          (click)="previousPage()"
          [disabled]="currentPage === 1"
          type="button">
          <i class="fas fa-chevron-left"></i>
        </button>

        <button
          *ngIf="getPageNumbers()[0] > 1"
          class="btn-pagination"
          (click)="goToPage(1)"
          type="button">
          1
        </button>

        <span *ngIf="getPageNumbers()[0] > 2" class="pagination-ellipsis">...</span>

        <button
          *ngFor="let page of getPageNumbers()"
          class="btn-pagination"
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
          type="button">
          {{ page }}
        </button>

        <span *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1" class="pagination-ellipsis">...</span>

        <button
          *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages"
          class="btn-pagination"
          (click)="goToPage(totalPages)"
          type="button">
          {{ totalPages }}
        </button>

        <button
          class="btn-pagination"
          (click)="nextPage()"
          [disabled]="currentPage === totalPages"
          type="button">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        (click)="confirmSelection()" 
        type="button"
        [disabled]="!selectedCustomer || isLoading">
        <i class="fas" [class.fa-spinner]="isLoading" [class.fa-spin]="isLoading" [class.fa-check]="!isLoading"></i>
        {{ isLoading ? 'Carregando...' : 'Selecionar' }}
      </button>
    </div>
  </div>
</div>

